import { daysOfWeekText } from "@dcc/types/dayOfWeek";
import { UnitsAndCaloriesPerDay } from "@dcc/types/drinkingDay";

export interface DailyUnitsForEachWeekDay {
  [day: number]: {
    desc: string;
    units: undefined | number;
  };
}

export const getDailyUnitsForEachWeekDay = ({
  drinkFreeDays,
  unitsAndCaloriesPerDay
}: {
  drinkFreeDays: number[];
  unitsAndCaloriesPerDay: UnitsAndCaloriesPerDay[];
}) =>
  Object.entries(daysOfWeekText).reduce(
    (agg: DailyUnitsForEachWeekDay, value) => {
      const [key, description] = value;

      if (drinkFreeDays.includes(Number(key))) {
        agg[Number(key)] = {
          desc: description.short,
          units: undefined
        };
      } else {
        const measures = unitsAndCaloriesPerDay.find(
          (day) => day.day === Number(key)
        );

        agg[Number(key)] = {
          desc: description.short,
          units: measures !== undefined ? measures.units : undefined
        };
      }
      return agg;
    },
    {}
  );
